// extracted by mini-css-extract-plugin
export default {"wrap":"ControlConfigDiff_wrap__t0YmN","pageContent":"ControlConfigDiff_pageContent__QnvUM","diffValue":"ControlConfigDiff_diffValue__TXDff"};